//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowSelect",
    props: {
        id: {
            default: "",
            type: String,
        },
        name: {
            default: "",
            type: String,
        },
        options: {
            default: () => [],
            type: Array,
        },
        onchange: {
            default: (e) => ({}),
            type: Function,
        },
    },
    data: () => ({}),
    methods: {
        handleChange(e) {
            this.onchange(e);
        },
    },
};
